var PUBLIC_URL = 'https://js.stytch.com/stytch.js';
function getJSUrl() {
    try {
        if (process.env.STYTCH_JS_SDK_URL) {
            return process.env.STYTCH_JS_SDK_URL;
        }
        if (process.env.REACT_APP_STYTCH_JS_SDK_URL) {
            return process.env.REACT_APP_STYTCH_JS_SDK_URL;
        }
        if (process.env.NEXT_PUBLIC_STYTCH_JS_SDK_URL) {
            return process.env.NEXT_PUBLIC_STYTCH_JS_SDK_URL;
        }
        if (process.env.STORYBOOK_STYTCH_JS_SDK_URL) {
            return process.env.STORYBOOK_STYTCH_JS_SDK_URL;
        }
        return PUBLIC_URL;
    }
    catch (err) {
        return PUBLIC_URL;
    }
}
var STYTCH_JS_URL = getJSUrl();

var findOrCreateScript = function () {
    var scripts = document.querySelectorAll("script[src=\"" + STYTCH_JS_URL + "\"]");
    if (scripts[0]) {
        return scripts[0];
    }
    var script = document.createElement('script');
    script.src = STYTCH_JS_URL;
    document.head.appendChild(script);
    return script;
};
var loadScript = function () {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    if (!isBrowser) {
        return Promise.resolve(null);
    }
    return new Promise(function (resolve, reject) {
        if (window.Stytch) {
            return resolve(window.Stytch);
        }
        var script = findOrCreateScript();
        script.addEventListener('load', function () {
            if (window.Stytch) {
                resolve(window.Stytch);
            }
            else {
                reject(new Error('Stytch.js could not be loaded'));
            }
        });
        script.addEventListener('error', function () {
            reject(new Error('Stytch.js could not be loaded'));
        });
    });
};
// Execute our own script injection after a tick to give users time to do their
// own script injection.
var stytchPromise = Promise.resolve().then(function () { return loadScript(); });
var loadCalled = false;
// We will log a warning if it doesn't look like the host code has checked or invoked the promise
stytchPromise.catch(function (err) {
    if (!loadCalled) {
        console.warn(err);
    }
});
var loadStytch = function () {
    loadCalled = true;
    return stytchPromise;
};

// Callback types
var EventType;
(function (EventType) {
    EventType["CallbackEvent"] = "CALLBACK_EVENT";
    EventType["ErrorEvent"] = "ERROR_EVENT";
    EventType["SuccessEvent"] = "SUCCESS_EVENT";
})(EventType || (EventType = {}));
var CallbackEventType;
(function (CallbackEventType) {
    CallbackEventType["UserEventType"] = "USER_EVENT_TYPE";
})(CallbackEventType || (CallbackEventType = {}));
var SDKProductTypes;
(function (SDKProductTypes) {
    SDKProductTypes["emailMagicLinks"] = "emailMagicLinks";
    SDKProductTypes["oauth"] = "oauth";
    SDKProductTypes["otp"] = "otp";
    SDKProductTypes["crypto"] = "crypto";
})(SDKProductTypes || (SDKProductTypes = {}));
var OAuthProvidersTypes;
(function (OAuthProvidersTypes) {
    OAuthProvidersTypes["Google"] = "google";
    OAuthProvidersTypes["Microsoft"] = "microsoft";
    OAuthProvidersTypes["Apple"] = "apple";
    OAuthProvidersTypes["Github"] = "github";
    OAuthProvidersTypes["GitLab"] = "gitlab";
    OAuthProvidersTypes["Facebook"] = "facebook";
    OAuthProvidersTypes["Coinbase"] = "coinbase";
    OAuthProvidersTypes["Discord"] = "discord";
    OAuthProvidersTypes["Slack"] = "slack";
    OAuthProvidersTypes["Amazon"] = "amazon";
    OAuthProvidersTypes["Bitbucket"] = "bitbucket";
    OAuthProvidersTypes["LinkedIn"] = "linkedin";
})(OAuthProvidersTypes || (OAuthProvidersTypes = {}));
var OneTapPositions;
(function (OneTapPositions) {
    OneTapPositions["embedded"] = "embedded";
    OneTapPositions["floating"] = "floating";
})(OneTapPositions || (OneTapPositions = {}));
var OTPMethods;
(function (OTPMethods) {
    OTPMethods["SMS"] = "sms";
    OTPMethods["WhatsApp"] = "whatsapp";
    OTPMethods["Email"] = "email";
})(OTPMethods || (OTPMethods = {}));

var initStytch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof window === 'undefined') {
        return null;
    }
    if (!window.Stytch) {
        throw new Error("Stytch has not been loaded.\nMake sure the script tag exists in the document head:\n```\n<script src=\"https://js.stytch.com/stytch.js\"></script>\n```\n\nIf using Next.js be sure to load Stytch using the beforeInteractive strategy in pages/_app.jsx:\n```\nimport Script from 'next/script';\n...\n<Script src=\"https://js.stytch.com/stytch.js\" strategy=\"beforeInteractive\" />\n```\n");
    }
    return window.Stytch.apply(window, args);
};
var loadAndInitStytch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return loadStytch().then(function (stytchFactory) { return stytchFactory && stytchFactory.apply(void 0, args); });
};

export { CallbackEventType, EventType, OAuthProvidersTypes, OTPMethods, OneTapPositions, SDKProductTypes, initStytch, loadAndInitStytch, loadStytch };
//# sourceMappingURL=index.esm.js.map
